import { ACTION_STATES, ComplexAction, createHandler, createReducer } from "core/actions";
import log from "loglevel";

export const initState = {
    open: false,
    editing: false,
    id: null,
    values: null,
    loadStatus: ACTION_STATES.NO_REQUEST,
    addStatus: ACTION_STATES.NO_REQUEST,
    editStatus: ACTION_STATES.NO_REQUEST,
    callback: null,
};

export class TOGGLE_RELATED_FILM_FORM extends ComplexAction {
    constructor() {
        const props = {
            error: false,
        };
        super(null, props);
    }
    sendRdx(state, { payload }) {
        return {
            ...state,
            open: !state.open,
            editing: payload && payload.editing,
            id: payload && payload.id,
            loadStatus: payload && payload.editing && ACTION_STATES.SEND,
        };
    }
    successRdx(state, { payload }) {
        return {
            ...state,
            values: payload ? payload.data : null,
            loadStatus: payload && ACTION_STATES.SUCCESS,
        };
    }
}

export class ADD_RELATED_FILM extends ComplexAction {
    constructor() {
        const props = {
            loadingAtr: "addStatus",
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("[ADD_RELATED_FILM] sendRdx", state, payload);

        return {
            ...state,
            addStatus: ACTION_STATES.SEND,
            values: payload.values,
            callback: payload.callback,
        };
    }
    successRdx(state) {
        return Object.assign({}, state, {
            addStatus: ACTION_STATES.SUCCESS,
            open: false,
            editing: false,
            values: null,
        });
    }
}
export class EDIT_RELATED_FILM extends ComplexAction {
    constructor() {
        const props = {
            loadingAtr: "editStatus",
        };
        super(props);
    }

    sendRdx(state, { payload }) {
        log.debug("[EDIT_RELATED_FILM] sendRdx", state, payload);

        return {
            ...state,
            editStatus: ACTION_STATES.SEND,
            values: payload.values,
            callback: payload.callback,
        };
    }
    successRdx(state, { payload }) {
        log.debug("[EDIT_RELATED_FILM] successRdx", state, payload);
        return Object.assign({}, state, {
            editStatus: ACTION_STATES.SUCCESS,
            open: false,
            editing: false,
            values: null,
        });
    }
}

export const actions = {
    EDIT_RELATED_FILM: new EDIT_RELATED_FILM(),
    ADD_RELATED_FILM: new ADD_RELATED_FILM(),
    TOGGLE_RELATED_FILM_FORM: new TOGGLE_RELATED_FILM_FORM({ loadingAtr: "loadStatus" }),
};

const handlers = createHandler(actions);

export default createReducer(initState, handlers);
